import React from 'react';

import GooglePlaceAutocomplete from 'material-ui-places';
 
class AddressField extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      address: ''
    };

    this.setAddress = this.setAddress.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onNewRequest = this.onNewRequest.bind(this);
  }

  setAddress(address) {
    this.props.fieldChanged('address', address);
  }

  onChange(evt) {
    const address = evt.target.value;
    this.setAddress(address);
  }

  onNewRequest(selectedData, searchedText, selectedDataIndex) {
    this.setAddress(selectedData.description);
  }
 
  render() {
    return (
      <GooglePlaceAutocomplete
        name="location"
        location={{lat: -33.865143, lng: 151.209900}}
        style={this.props.styles.textField}
        fullWidth={true}
        hintStyle={this.props.styles.hintStyle}
        inputStyle={this.props.styles.inputStyle}
        floatingLabelText={this.props.details.address ? 'Car Address' : ' '}
        hintText="Car Address"
        floatingLabelFixed={true}
        searchText={this.props.details.address}
        onChange={this.onChange}
        onNewRequest={this.onNewRequest}
      />
    );
  }
}
 
export default AddressField;



// WEBPACK FOOTER //
// ./src/components/AddressField.js